export class ChangePassword {
    username: string;
    oldPassword: string;
    newPassword1: string;
    newPassword2: string;

    isChanged: boolean;
    failReason: string;
}